// MultiImageDropzone.tsx
import React, { useCallback } from 'react';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CategoriasI } from '../../models/home';
import ItemCategoria from './SortableImageItem';

interface MultiCategoriasDropzoneProps {
  categorias: CategoriasI;
  setCategorias: (categorias: CategoriasI) => void;
  onRemove: (index: number) => void;
  title: string;
  handleImageFieldChange: (index: number, field: "nombre" | "imagen" | "categoria" | "orden", value: string | File, name: "categorias") => void
}

const MultiCategoriasDropzone: React.FC<MultiCategoriasDropzoneProps> = ({
  categorias,
  setCategorias,
  onRemove,
  title,
  handleImageFieldChange,
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  const handleDrop = useCallback(
    (e: React.DragEvent<HTMLDivElement>) => {
      e.preventDefault();
      const files = Array.from(e.dataTransfer.files).filter((file) =>
        file.type.startsWith('image/') || file.type === 'image/gif'
      );

      console.log(files)

      const nuevas = files.map((file, i) => ({
        media:file ,
        imagen: URL.createObjectURL(file),
        nombre: '',
        categoria: '',
        orden: categorias?.length + i,
      }));

      console.log(nuevas)

      setCategorias([...(categorias || []), ...nuevas]);

      console.log(categorias)
    },
    [categorias, setCategorias]
  );
  

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };


  const handleInputChange = (
    index: number,
    name: 'nombre' | 'categoria',
    value: string
  ) => {
    const updated = [...categorias];
    updated[index][name] = value;

    console.log(updated)

    setCategorias(updated);
  };

  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = categorias.findIndex((i) => i.orden === active.id);
      const newIndex = categorias.findIndex((i) => i.orden === over.id);
      const reordenadas = arrayMove(categorias, oldIndex, newIndex);

      // Reasignar el campo 'orden' según la nueva posición
      const conOrden = reordenadas.map((img, i) => ({ ...img, orden: i }));
      setCategorias(conOrden);
    }
  };
  

  return (
    <div>
      <label>{title}(arrástralas aquí)</label>
      <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        style={{
          border: '2px dashed #ccc',
          padding: '20px',
          marginBottom: '20px',
          textAlign: 'center',
          borderRadius: '8px',
        }}
      >
        Suelta aquí tus imágenes o GIFs
      </div>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={categorias?.map((categoria) => categoria.orden)}
          strategy={verticalListSortingStrategy}
        >
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {categorias?.map((categoria, index) => (
              <ItemCategoria
                key={index}
                categoria={categoria}
                index={index}
                onRemove={onRemove}
                handleInputChange={handleInputChange}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </div>
  );
};

export default MultiCategoriasDropzone;
